// oxlint-disable react-perf/jsx-no-jsx-as-prop
import { useMe } from "@auth/useMe"
import { createFileRoute, Link, Outlet } from "@tanstack/react-router"
import { CollapsibleSidebar, sidebarItem, tokens } from "@ui"
import { css } from "dx-styles"

import {
  AiAgentsIcon,
  ConversationsIcon,
  DataIcon,
  InsightsIcon,
  KnowledgeIcon,
  PuzzelLogo,
  ShieldIcon,
} from "../../components/Icons"
import { canViewErrors } from "./superpowers/errors/-enabled"

const shell = css({
  display: "flex",
  minHeight: "100vh",
  // Aurora backdrop: warm glow bottom-left blending into a lavender wash on the right.
  backgroundColor: "#ffffff",
  backgroundImage: [
    "radial-gradient(60% 55% at 34% 96%, rgba(250, 176, 72, 0.95) 0%, rgba(250, 176, 72, 0.55) 32%, rgba(250, 176, 72, 0) 68%)",
    "radial-gradient(46% 42% at 58% 95%, rgba(240, 150, 162, 0.5) 0%, rgba(240, 150, 162, 0) 70%)",
    "radial-gradient(55% 40% at 90% 94%, rgba(199, 150, 245, 0.85) 0%, rgba(199, 150, 245, 0.4) 40%, rgba(199, 150, 245, 0) 74%)",
    "radial-gradient(70% 46% at 104% 96%, rgba(214, 180, 250, 0.6) 0%, rgba(214, 180, 250, 0) 76%)",
  ].join(", "),
  backgroundAttachment: "fixed",
})
const innerShell = css({ display: "flex", flex: "1", height: "100vh" })
const content = css({
  paddingInline: tokens.space.md,
  paddingTop: "2rem",
  width: "100%",
  borderWidth: "0px", //ehh
  borderInlineWidth: "2px",
  borderColor: tokens.color.surface,
  borderStyle: "solid",
  height: "100%",
  maxWidth: "1218px",
  marginInline: "auto",
  overflowY: "auto",
  background:
    "linear-gradient(114deg, rgba(255, 255, 255, 0.60) 2.72%, rgba(255, 255, 255, 0.80) 100.25%)",
  backdropFilter: "blur(10px)",
})

const RouteComponent = () => {
  const me = useMe()

  return (
    <div className={shell}>
      <CollapsibleSidebar
        logo={
          <Link to="/">
            <PuzzelLogo />
          </Link>
        }
      >
        <Link
          to="/conversations"
          className={sidebarItem}
        >
          <ConversationsIcon />
          Conversations
        </Link>
        <Link
          to="/insights"
          className={sidebarItem}
        >
          <InsightsIcon />
          Insights
        </Link>
        <Link
          to="/knowledgebase"
          className={sidebarItem}
        >
          <KnowledgeIcon />
          Knowledge
        </Link>
        <Link
          to="/ai-agents"
          className={sidebarItem}
        >
          <AiAgentsIcon />
          AI agents
        </Link>
        <CollapsibleSidebar.Footer>
          <Link
            to="/data"
            className={sidebarItem}
          >
            <DataIcon />
            Data
          </Link>
          {canViewErrors(me) ? (
            <Link
              to="/superpowers/errors"
              className={sidebarItem}
            >
              <ShieldIcon />
              Errors
            </Link>
          ) : undefined}
        </CollapsibleSidebar.Footer>
      </CollapsibleSidebar>
      <div className={innerShell}>
        <div className={content}>
          <div>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export const Route = createFileRoute("/_chrome")({
  component: RouteComponent,
})
